import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import {
  Box,
  // Heading,
  Button,
  Text,
  // TableContainer,
  Table,
  // Thead,
  Tr,
  Td,
  // Th,
  Tbody,
  Select,
  VStack,
} from '@chakra-ui/react';
import { getOrder, settleItem, auth } from './api';
import compact from './utils/compact';
import { useAuthState } from 'react-firebase-hooks/auth';

export const getOrderSummary = (order) => {
  if (!order?.length) return { text: 'Ordine da evadere', color: 'tomato' };
  if (order.every((item) => (item.quantity || 0) + (item.free || 0) === (item.delivered || 0))) {
    return { text: 'Ordine completamente evaso!', color: 'gold' };
  }
  if (order.some((item) => (item.delivered || 0) !== 0)) {
    return { text: 'Ordine parzialmente evaso', color: 'orange' };
  }
  return { text: 'Ordine da evadere', color: 'tomato' };
};

const getSummary = getOrderSummary;

// Orario di pranzo deve essere consumato in quel giorno prima delle 16
// Orario di cena deve essere consumato in quel giorno dopo le 16

const checkSelectedDateValidity = (date) => {
  if (!date) return true;

  const now = new Date();
  const selectedDate = new Date(date);

  // Same day
  if (now.toDateString() !== selectedDate.toDateString()) return false;

  // Selezionato Pranzo e siamo ancora in orario pranzo (<16)
  if (selectedDate.getHours() <= 16 && now.getHours() <= 16) return true;

  // console.log('now', now.toDateString(), now.getHours() )
  // console.log('selectedDate', selectedDate.toDateString(), selectedDate.getHours() )
  // console.log('ssssss',selectedDate.getHours() > 16 && now.getHours() > 16)
  // Selezionata Cena e siamo dopo pranzo (>16)
  return selectedDate.getHours() >= 16 && now.getHours() >= 16;
};

const Selectino = React.forwardRef((props, ref) => {
  const { numElements, disabled } = props;
  // console.log('NUME ELMENTS', numElements);
  // const [v, setV] = useState();

  const array = [...Array(numElements).keys()];
  return (
    <Select
      disabled={disabled}
      // pr={'-32px'}
      border={'0px'} // Tenere
      ref={ref}
      size='sm'
      backgroundColor={'brand.500'}
      color='gold'
      fontWeight='600'
      defaultValue={numElements}
      // icon={<></>}
      // value={v ? v : numElements}
      // onChange={(event) => {
      //   setV(event.target.value)
      //   onChange(event.target.value);
      // }}
    >
      {array.map((_, index) => {
        return (
          <option key={index + 1} value={index + 1}>
            {index + 1}
          </option>
        );
      })}
    </Select>
  );
});

function Order() {
  const isDemo = process.env.REACT_APP_IS_DEMO === 'true';

  const [user] = useAuthState(auth);
  const { orderId } = useParams();
  const [orderInfo, setOrderInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [forceSettleOrder, setForceSettleOrder] = useState(false);

  const elRefs = React.useRef([]);

  // console.log('===>', user);

  // Determina se l'utente può smarcare
  const canSettle = user && (user.displayName === 'admin' || user.displayName === 'operator');

  const _settleItem = async (_orderId, _itemId, _toDeliver) => {
    setIsLoading(true);
    const { success, error } = await settleItem(_orderId, _itemId, _toDeliver, user.email);
    if (!success) {
      console.log('Error', error);
    }
    await _getOrder(_orderId);
    setIsLoading(false);
  };

  const _getOrder = async (_orderId) => {
    const o = await getOrder(_orderId);
    o.compact = compact(o.order);
    setOrderInfo(o);

    if (elRefs.current.length !== o.compact.length) {
      // add or remove refs
      elRefs.current = Array(o.compact.length)
        .fill()
        .map((_, i) => elRefs.current[i] || React.createRef());
    }
  };

  useEffect(() => {
    _getOrder(orderId);
  }, [orderId]);

  if (!orderInfo) return <div>Loading...</div>;

  let status;
  let colorStatus;

  if (orderInfo.status === 'paid') {
    status = 'pagato';
    colorStatus = 'gold';
  }
  if (orderInfo.status === 'unpaid') {
    status = 'non pagato';
    colorStatus = 'tomato';
  }
  if (orderInfo.status === 'refunded') {
    status = 'rimborsato';
    colorStatus = 'tomato';
  }
  const summary = getSummary(orderInfo.compact);
  const options = {
    // weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  };

  const isSelectedDateValidNow = checkSelectedDateValidity(orderInfo.selectedDate);

  // console.log('isSelectedDateValidNow', isSelectedDateValidNow)
  // Ordine non pagato/rimborsato oppure non sei admin oppure invalid Selected Date
  const disableSettleOrder =
    !forceSettleOrder && (orderInfo.status === 'unpaid' || orderInfo.status === 'refunded' || !isSelectedDateValidNow || !canSettle);

  const padding = 2;
  return (
    <Box w={'100%'} color='white' my={50} bg='#3c4d5f' textAlign={'center'}>
      <Text fontSize={'md'}>Id Ordine {orderId}</Text>
      <Text fontSize={'md'}>
        Creato il {new Date(orderInfo.createdAt).toLocaleDateString('it', options)}
      </Text>
      {orderInfo.selectedDate && (
        <Text fontSize={'md'}>
          Per la data{' '}
          {new Date(orderInfo.selectedDate).toLocaleDateString('it', {
            month: 'long',
            day: 'numeric',
          })}{' '}
          ({new Date(orderInfo.selectedDate).getHours() > 16 ? 'cena' : 'pranzo'})
        </Text>
      )}
      <Text fontSize={'md'} color={colorStatus}>
        Status {status}
      </Text>

      {/* TABLE CONTAINER NON PERMETTE IL TESTO DI ANDARE SU DUE RIGHE */}
      {/* <TableContainer my={10}> */}
      <Box my={10}>
        <Text fontSize='24' color={summary.color} textAlign={'center'}>
          {summary.text}
        </Text>
        <Table variant='simple' colorScheme='teal' backgroundColor='#273149'>
          <Tbody>
            {orderInfo.compact.map((item, index) => {
              const totalQuantity = item.quantity + item.free || 0;
              // console.log(item, totalQuantity)
              return (
                <Tr key={index}>
                  <Td p={padding}>{item.productTitle}</Td>
                  <Td p={padding}>
                    {item.delivered}/{totalQuantity}
                  </Td>
                  <Td minWidth={'80px'} p={padding}>
                    {totalQuantity - item.delivered ? (
                      <Selectino
                        ref={elRefs.current[index]}
                        disabled={disableSettleOrder}
                        numElements={totalQuantity - item.delivered}
                      />
                    ) : (
                      ''
                    )}
                  </Td>
                  <Td textAlign='center' p={padding} color='gold'>
                    {totalQuantity - item.delivered ? (
                      <Button
                        size='sm'
                        isLoading={isLoading}
                        disabled={disableSettleOrder}
                        onClick={() => {
                          _settleItem(orderId, item.productId, elRefs.current[index].current.value);
                        }}
                      >
                        OK
                      </Button>
                    ) : (
                      <Text textAlign='center' fontSize='sm'>
                        Completo
                      </Text>
                    )}
                  </Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </Box>
      {/* </TableContainer> */}

      {/* BLOCCO DATA */}
      {!isSelectedDateValidNow && (
        <Box borderRadius={5} p={2} border='2px solid teal'>
          <Text fontSize={'md'} color={'gold'}>
            L'ordine può essere evaso solo il giorno{' '}
          </Text>
          <Text fontSize={'md'} fontWeight={800} color={'gold'}>
            {new Date(orderInfo.selectedDate).toLocaleDateString('it', {
              month: 'long',
              day: 'numeric',
            })}{' '}
            {new Date(orderInfo.selectedDate).getHours() < 16
              ? 'prima delle 16.00'
              : 'dopo le 16.00'}
          </Text>
          {canSettle && (
            <>
              {forceSettleOrder ? (
                <Button my={3} size='sm' onClick={() => setForceSettleOrder(false)}>
                  Abilita controllo data
                </Button>
              ) : (
                <Button my={3} size='sm' onClick={() => setForceSettleOrder(true)}>
                  Disabilita controllo data
                </Button>
              )}
            </>
          )}
        </Box>
      )}

      {/* DEVI LOGGARTI COME ADMIN */}
      {isDemo && !canSettle && (
        <VStack>
          <Text mt={10} color='gold' fontSize={'md'}>
            Devi loggarti come admin o operatore per smarcare i prodotti da consegnare.
          </Text>
          <Button as={Link} to='/dashboard' mt={50} size={'sm'}>
            Login
          </Button>
        </VStack>
      )}

      {/* RICOMINCIA LA DEMO */}
      {isDemo && (
        <Button as={Link} to='/' mt={50} size={'md'}>
          Ricomincia la demo
        </Button>
      )}
    </Box>
  );
}

export default Order;
